import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

// Wrapper ngoài cùng: viền gradient + shadow
const StyledNewCustomPackageWrapper = styled('div')`
  position: relative;
  border-radius: 24px;
  width: 318px;
  padding: 1px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  background: linear-gradient(
    106.46deg,
    #f48b71 15.23%,
    #f1414d 42.62%,
    #563efa 99.91%
  );
`;

// Card bên trong: background image
const StyledNewCustomPackageCard = styled('div')`
  border-radius: 23px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-image: url('https://media-frontend.vbee.vn/images/package/vip-plus-package-bg.webp');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

// Content chính
const StyledNewCustomPackageContent = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;

  .top-section {
    display: flex;
    flex-direction: column;
    gap: 40px;
    flex: 1;
  }

  .header-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 80px;
  }

  .description-text {
    font-size: 14px;
    font-weight: 400;
    color: rgba(28, 28, 30, 0.64);
  }

  .price-section {
    display: flex;
    flex-direction: column;
    gap: 25px;
    flex-grow: 1;
    justify-content: flex-start;
  }

  .price-display {
    min-height: 63px;
  }

  .buy-button-section {
    min-height: 80px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    justify-content: flex-start;
  }

  .divider-section {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .divider-line {
    border-bottom: 1px solid rgba(30, 22, 78, 0.08);
    width: 100%;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .features-title {
    font-size: 16px;
    font-weight: 600;
    color: #1c1c1e;
    line-height: 24px;
  }

  .resources-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

// Button "Mua ngay"
const StyledBuyButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border-radius: 12px;
  background: white;
  font-size: 16px;
  font-weight: 600;
  color: #1e164e;
  border: 1px solid rgba(30, 22, 78, 0.16);
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;

  &:hover {
    background: #f9fafb;
  }
`;

// Label cho option (credit/resource)
const StyledOptionLabel = styled('span')`
  font-size: 14px;
  font-weight: 400;
  color: #1c1c1e;
`;

// Wrapper cho CreditSelector
const StyledCreditSelectorWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export {
  StyledNewCustomPackageWrapper,
  StyledNewCustomPackageCard,
  StyledNewCustomPackageContent,
  StyledBuyButton,
  StyledOptionLabel,
  StyledCreditSelectorWrapper,
};
